import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ui-icon-window-minimize',
    templateUrl: './icon-window-minimize.component.svg',
    styleUrls: ['../icon-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class IconWindowMinimizeComponent { }
